  
<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    :key="isSidebarActiveLocal"
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{ Object.entries(this.data).length === 0 ? "ADD NEW" : "UPDATE" }} ITEM</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component
      :is="scrollbarTag"
      class="scroll-area--data-list-add-new"
      :settings="settings"
      :key="$vs.rtl"
    >
      <div class="p-6">
        <form>
          <component
            :baseUrl="baseUrl"
            :uploadEndpoint="uploadEndpoint"
            :is="fName.type"
            :structure="fName"
            v-for="(fName,fIndex) in showFormFields"
            :key="test(data[fIndex],fIndex)"
            :value="currentData[fIndex]"
            :index="fIndex"
            @input="(data) => updateInputParams(data)"
            @error="(value) => handleErrors(value)"
          >{{fName.type}}</component>
        </form>
        {{analyzeFieldStructure}}
        <vs-alert v-show="showError" title="Error" color="warning" active="true">
          <template v-for="(obj,i) in errorMsg">
            <vs-divider :key="i">i</vs-divider>obj
          </template>
        </vs-alert>
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="disableSubmitBtn">Submit</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>
 
<script>
import axios from "@/axios.js";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

import { withValidation } from "vee-validate";
import aronTextbox from "../formElements/textbox";
import aronPassword from "../formElements/password";
import aronSelect from "../formElements/select";
import aronMultiSelect from "../formElements/multiselect";
import aronRadio from "../formElements/radio";
import aronRadioStatic from "../formElements/radioStatic";
import aronTextarea from "../formElements/textArea";
import aronCurrency from "../formElements/currency";
import aronNumber from "../formElements/number";
import aronInteger from "../formElements/integer";
import aronDate from "../formElements/date";
import aronYearOnly from "../formElements/yearOnly";
import aronFile from "../formElements/file";
import aronCheckbox from "../formElements/checkbox";
import aronSwitch from "../formElements/switch";
import aronTime from "../formElements/time";
//mixin
import { alertMixin } from "../../../mixin/alertMixin";
import { axiosMixin } from "../../../mixin/axiosMixin";
import { helperMixin } from "../../../mixin/helperMixin";


import { mapGetters } from "vuex";

export default {
  components: {
    VuePerfectScrollbar,
    aronTextbox,
    aronPassword,
    aronSelect,
    aronMultiSelect,
    aronRadio,
    aronRadioStatic,
    aronTextarea,
    aronCurrency,
    aronNumber,
    aronInteger,
    aronDate,
    aronYearOnly,
    aronFile,
    aronCheckbox,
    aronSwitch,
    aronTime
  },
  mixins: [alertMixin, axiosMixin, helperMixin],
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    },
    addionalData: {
      type: Object,
      default: () => {}
    },
    fieldStructure: {
      type: Object,
      default: () => {},
      required: true
    },
    endPoint: {
      type: String
    },
    uploadEndpoint: {
      type: String
    }
  },
  data() {
    return {
      valueof: this.$store.state.profile.currentColumnValue,
      baseUrl: axios.defaults.baseURL,
      inputParams: {},
      errorParams: [],
      disableSubmitBtn: true,
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      },
      //handles the error in sidebar
      showError: false,
      errorMsg: {}
    };
  },
  watch: {
    isSidebarActive(val) {
      if (!val) return;
      if (Object.entries(this.data).length === 0) {
        // this.$validator.reset()
      } else {
        let { category, id, img, name, order_status, price } = JSON.parse(
          JSON.stringify(this.data)
        );
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    }
  },
  computed: {
    ...mapGetters({
      scrollbarTag: "main/scrollbarTag",
      getCurrentColumnValue: "profile/getCurrentColumnValue"
    }),
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },

    analyzeFieldStructure() {
      var defaultError = false;
      if (Object.entries(this.data).length > 0) {
        defaultError = true;
      }

      for (var data in this.showFormFields) {
        if (data == "password") {
          this.errorParams["password_confirmation"] = defaultError;
        }
        this.errorParams[data] = defaultError;
      }
      this.updateSubmitButton();
    },

    isFormValid() {
      return false;
    },
    showFormFields() {
      return _.pickBy(this.fieldStructure, function(st) {
        return st.showInJointList == "yes";
      });
    },
    currentData() {
      return this.data;
    },
    operation() {
      return Object.entries(this.data).length > 0 ? "update" : "add";
    }
  },
  methods: {
    test(data, index) {
      return data + "_" + index;
    },
    updateInputParams(data) {
      this.inputParams[data.index] = data.value;
    },
    promiseHandler(endpoint) {
      return axios.get(endpoint);
    },
    submitData() {
      // remove the error msg
      this.showError = false;
      this.errorMsg = {};

      this.aronPostPut(
        this.endPoint,
        this.operation,
        this.inputParams,
        this.data.id
      )
        .then(response => {
          this.isSidebarActiveLocal = false;

          for (const fieldName in this.inputParams) {
            this.data[fieldName] = this.inputParams[fieldName];
          }

          if (this.operation == "add") {
            this.$emit("addNew", response.data);
          } else {
            this.$emit("updateRow", response.data);
          }
        })
        .catch(error => {});
    },
    updateCurrImg(input) {
      if (input.target.files && input.target.files[0]) {
        var reader = new FileReader();
        reader.onload = e => {
          this.dataImg = e.target.result;
        };
        reader.readAsDataURL(input.target.files[0]);
      }
    },
    handleErrors(data) {
      this.errorParams[data.index] = data.value;

      console.log("this.errorParams:", this.errorParams);
      this.updateSubmitButton();
    },
    updateSubmitButton() {
      this.disableSubmitBtn = false;
      for (const id in this.errorParams) {
        if (!this.errorParams[id]) {
          this.disableSubmitBtn = true; 
          return false;
        }
      }
    }
  },

  beforeUpdate() {},
  created() {
    this.addToObject(this.inputParams, this.addionalData);
  }
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
